import { replace, type RouteObject } from 'react-router'
import { links } from '@/utils/link'
import type { WaitForAuthResolutionFn } from '@/features/iam'
import type { PayoutsFeature } from '@/features/payouts'
import { createProPayoutsViewLoader } from './payout-route-loaders'

/**
 * Options for {@link createRoutes}.
 */
export interface CreatePayoutsRoutesOptions {
  payouts: PayoutsFeature
  waitForAuthResolution: WaitForAuthResolutionFn
}

/**
 * Creates routes for the payouts feature.
 */
export function createRoutes(
  options: CreatePayoutsRoutesOptions,
): RouteObject[] {
  return [
    {
      path: '/payouts/*',
      loader: createProPayoutsViewLoader(options),
      lazy: {
        Component: () =>
          import('@/features/payouts/pro/components/ProPayoutsView/ProPayoutsViewContainer').then(
            (r) => r.default,
          ),
      },
    },
  ]
}

/**
 * Creates the payouts admin pages, for admin to mount under its payouts path.
 */
export function createAdminRoutes(): RouteObject[] {
  return [
    {
      lazy: {
        Component: () =>
          import('@/features/payouts/admin/PayoutsAdminContainer').then(
            (r) => r.default,
          ),
      },
      children: [
        {
          index: true,
          loader: () => replace(links.adminPayoutsReview()),
          Component: null,
        },
        {
          path: 'review/*',
          lazy: {
            Component: () =>
              import('@/features/payouts/admin/PayoutsAdminReviewContainer').then(
                (r) => r.default,
              ),
          },
        },
        {
          path: 'transactions/*',
          lazy: {
            Component: () =>
              import('@/features/payouts/admin/PayoutsAdminTransactionsContainer').then(
                (r) => r.default,
              ),
          },
        },
        // Unknown payouts admin paths keep the page title, with an empty page.
        { path: '*', Component: null },
      ],
    },
  ]
}
